// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.object-block{
   border: var(--border);
   padding: var(--padding);
   border-radius: var(--border-radius);
   min-width: fit-content;
}

.object-block .form-field{
   display: flex;
   flex-direction: column;
}

.object-block label{
   padding-left: unset;
}

.object-block .input-div{
   display: flex;
   flex-direction: row;
   width:100%;
}

.object-block .unit-label{
   font-weight: bold;
   padding-left: unset;
}

.object-block .required{
   color: var(--required)
}

.object-block .button-div{
   display: flex;
   justify-content: flex-end;
}

`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLObjectBlock/ECLObjectBlock.css"],"names":[],"mappings":"AAAA;GACG,qBAAqB;GACrB,uBAAuB;GACvB,mCAAmC;GACnC,sBAAsB;AACzB;;AAEA;GACG,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,UAAU;AACb;;AAEA;GACG,iBAAiB;GACjB,mBAAmB;AACtB;;AAEA;GACG;AACH;;AAEA;GACG,aAAa;GACb,yBAAyB;AAC5B","sourcesContent":[".object-block{\r\n   border: var(--border);\r\n   padding: var(--padding);\r\n   border-radius: var(--border-radius);\r\n   min-width: fit-content;\r\n}\r\n\r\n.object-block .form-field{\r\n   display: flex;\r\n   flex-direction: column;\r\n}\r\n\r\n.object-block label{\r\n   padding-left: unset;\r\n}\r\n\r\n.object-block .input-div{\r\n   display: flex;\r\n   flex-direction: row;\r\n   width:100%;\r\n}\r\n\r\n.object-block .unit-label{\r\n   font-weight: bold;\r\n   padding-left: unset;\r\n}\r\n\r\n.object-block .required{\r\n   color: var(--required)\r\n}\r\n\r\n.object-block .button-div{\r\n   display: flex;\r\n   justify-content: flex-end;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
